import Constants from '@/Constants';
import { AutoExecutableQuizRequest } from '@/models/AutoExecutableQuizRequest';
import { QuizData } from '@/models/QuizData';
import http from '@/services/HttpService';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import {
    getAutoExecutableQuizFailure,
    getAutoExecutableQuizSuccess,
    getQuizQuestionListFailure,
    getQuizQuestionListSuccess,
    getQuizResultListFailure,
    getQuizResultListSuccess,
    postQuizFailure,
    postQuizQuestionFailure,
    postQuizQuestionSuccess,
    postQuizResultFailure,
    postQuizResultSuccess,
    postQuizSuccess,
    putQuizQuestionReorderFailure,
    putQuizQuestionReorderSuccess,
} from './action';
import { QuizTypes } from './types';

export function* postQuizRequest(action: PayloadAction<QuizTypes.POST_QUIZ_REQUEST, QuizData>) {
    try {
        const response = yield call(http.post, `${Constants.BUZ_QUIZZES}`, action.payload);
        yield put(postQuizSuccess(response.data));
    } catch (err) {
        yield put(postQuizFailure(err));
    }
}

export function* getAutoExecutableQuizRequest(action: PayloadAction<QuizTypes.GET_AUTO_EXECUTABLE_QUIZ_REQUEST, AutoExecutableQuizRequest>) {
    try {
        const { applicationId, organizationId } = action.payload;
        const response = yield call(
            http.get,
            `${Constants.QUIZ_QUIZZES_AUTO_EXECUTE}/?applicationId=${applicationId}&organizationId=${organizationId}`,
        );
        yield put(getAutoExecutableQuizSuccess(response.data));
    } catch (err) {
        yield put(getAutoExecutableQuizFailure(err));
    }
}

export function* getQuizResultListRequest(action: PayloadAction<QuizTypes.GET_QUIZ_RESULT_LIST_REQUEST, number>) {
    try {
        const response = yield call(http.get, `${Constants.QUIZ_QUIZZES}/${action.payload}/results`);
        yield put(getQuizResultListSuccess(response.data));
    } catch (err) {
        yield put(getQuizResultListFailure(err));
    }
}

export function* getQuizResultRequest(action: PayloadAction<QuizTypes.GET_QUIZ_RESULT_REQUEST, number>) {
    try {
        const response = yield call(http.get, `${Constants.QUIZ_RESULTS}/${action.payload}`);
        yield put(postQuizResultSuccess(response.data));
    } catch (err) {
        yield put(postQuizResultFailure(err));
    }
}

export function* postQuizResultRequest(action: PayloadAction<QuizTypes.POST_QUIZ_RESULT_REQUEST, QuizData>) {
    try {
        const response = yield call(http.post, `${Constants.QUIZ_RESULTS}`, action.payload);
        yield put(postQuizResultSuccess(response.data));
    } catch (err) {
        yield put(postQuizResultFailure(err));
    }
}

export function* getQuizQuestionListRequest(action: PayloadAction<QuizTypes.GET_QUIZ_QUESTION_LIST_REQUEST, number>) {
    try {
        const { data } = yield call(http.get, `${Constants.QUIZ_QUIZZES}/${action.payload}/questions`);
        yield put(getQuizQuestionListSuccess(data));
    } catch (err) {
        yield put(getQuizQuestionListFailure(err));
    }
}

export function* postQuizQuestionRequest(action: PayloadAction<QuizTypes.POST_QUIZ_QUESTION_REQUEST, QuizData>) {
    try {
        const { data } = yield call(http.post, `${Constants.QUIZ_QUESTIONS}`, action.payload);
        yield put(postQuizQuestionSuccess(data));
    } catch (err) {
        yield put(postQuizQuestionFailure(err));
    }
}

export function* putQuizQuestionReorderRequest(
    action: PayloadAction<QuizTypes.PUT_QUIZ_QUESTION_REORDER_REQUEST, { questionId: number; order: number }>,
) {
    try {
        const { questionId, order } = action.payload;
        yield call(http.put, `${Constants.QUIZ_QUESTIONS}/${questionId}/reorder/${order}`);
        yield put(putQuizQuestionReorderSuccess());
    } catch (err) {
        yield put(putQuizQuestionReorderFailure(err));
    }
}
